export const HOME_PATH = '/';
export const STAMPS_PATH = '/stamps';
export const INBOX_PATH = '/inbox';
export const OUTBOX_PATH = '/outbox';
export const PRIVACY_POLICY_PATH = '/privacy-policy';
export const TERMS_OF_SERVICE_PATH = '/terms-of-service';
